<template>
  <div>
    EAN: {{ ean }} - Preis: {{ price }}
    <b-button
      class="mr-2"
      variant="outline-danger"
      @click="onClick"
    >
      Delete item
    </b-button>
  </div>
</template>

<script>
    export default {
        name: "ArticleListItem",
        props: ['ean', 'price'],
        methods: {
            onClick() {
                this.$emit('click')
            }
        }

    }
</script>
